import React from 'react';
import { FsProps, FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import i18next from 'i18next';
type Props = FsProps;
const gqlGet = gql`
  query getCollectionOrdersOriginatedfromStates($where: String, $offset: Int, $limit: Int, $order: String) {
    getCollectionOrdersOriginatedfromStates(
      where: $where
      offset: $offset
      limit: $limit
      order: $order
    ) {
      data {
        id: value
        description: name
      }
      recordCount
    }
  }
`;
export const FieldSelectOriginatedFromState = ({
  label = i18next.t('Προέλευση'),
  name = 'originatedFromId',
  defaultValues = {},
  ...rest
}: Props) => {
  function useGetLazyQuery() {
    return useLazyQuery(gqlGet, { fetchPolicy: 'network-only' });
    //return [null, { loading: null, data: null }];
  }
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      where={JSON.stringify({})}
      hook={useGetLazyQuery}
    />
  );
};
